import { API_ENDPOINTS } from '../config/apiConfig';

export interface SystemActivity {
  id: string;
  userId: string;
  userName: string;
  userFullName: string;
  activityType: string;
  activityDescription: string;
  application: string;
  applicationDisplayName: string;
  description: string;
  ipAddress: string;
  userAgent: string;
  activityTimestamp: string;
}

export interface ActivityResponse {
  success: boolean;
  message: string;
  data: SystemActivity[];
}

const activityService = {
  getRecentActivities: async (): Promise<ActivityResponse> => {
    try {
      const headers: Record<string, string> = { 'Content-Type': 'application/json' };
      const token = localStorage.getItem('token');
      if (token) headers.Authorization = `Bearer ${token}`;

      const response = await fetch(`${API_ENDPOINTS.authApi}/activities/recent`, {
        method: 'GET',
        headers,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching recent activities:', error);
      throw error;
    }
  },

  getRecentActivitiesWithLimit: async (limit: number): Promise<ActivityResponse> => {
    try {
      const url = `${API_ENDPOINTS.authApi}/activities/recent/${limit}`;
      const headers: Record<string, string> = { 'Content-Type': 'application/json' };
      const token = localStorage.getItem('token');
      if (token) headers.Authorization = `Bearer ${token}`;

      const response = await fetch(url, {
        method: 'GET',
        headers,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching recent activities:', error);
      throw error;
    }
  },

  getActivitiesByApplication: async (application: string): Promise<ActivityResponse> => {
    try {
      const headers: Record<string, string> = { 'Content-Type': 'application/json' };
      const token = localStorage.getItem('token');
      if (token) headers.Authorization = `Bearer ${token}`;

      const response = await fetch(`${API_ENDPOINTS.authApi}/activities/application/${application}`, {
        method: 'GET',
        headers,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching activities by application:', error);
      throw error;
    }
  },

  getActivitiesByUser: async (userId: string): Promise<ActivityResponse> => {
    try {
      const headers: Record<string, string> = { 'Content-Type': 'application/json' };
      const token = localStorage.getItem('token');
      if (token) headers.Authorization = `Bearer ${token}`;

      const response = await fetch(`${API_ENDPOINTS.authApi}/activities/user/${userId}`, {
        method: 'GET',
        headers,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching activities by user:', error);
      throw error;
    }
  },

  getActivitiesByType: async (activityType: string): Promise<ActivityResponse> => {
    try {
      const headers: Record<string, string> = { 'Content-Type': 'application/json' };
      const token = localStorage.getItem('token');
      if (token) headers.Authorization = `Bearer ${token}`;

      const response = await fetch(`${API_ENDPOINTS.authApi}/activities/type/${activityType}`, {
        method: 'GET',
        headers,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching activities by type:', error);
      throw error;
    }
  },
};

export default activityService; 